import {
  momentLocales,
} from '@/utils/language'

export const getMomentLocale = (payload) => {
  if (!payload) return Promise.resolve()
  const locale = payload.toLowerCase().replace('_', '-')
  let dynamicImport = momentLocales[locale]
  if (!dynamicImport) {
    const dynamicImportKey = Object.keys(momentLocales).find((key) => key.startsWith(locale))
    dynamicImport = dynamicImportKey ? momentLocales[dynamicImportKey] : dynamicImport
  }
  return dynamicImport ? dynamicImport().catch((err) => {
    // eslint-disable-next-line no-console
    console.error(`Failed to load moment locale for '${locale}'`, err)
  }) : Promise.resolve()
}
